import { OnboardingAnswers, QuestionDefinition } from '../types/onboarding';

export function shouldShowQuestion(
  question: QuestionDefinition,
  answers: OnboardingAnswers
): boolean {
  let directActive = false;
  try {
    directActive = typeof localStorage !== 'undefined' && localStorage.getItem('direct_connect_active') === 'true';
  } catch {
    directActive = false;
  }

  if (directActive && (question.id === 'seeker_email' || question.id === 'seeker_full_name')) {
    return false;
  }

  if (!question.showIf) return true;
  const target = answers[question.showIf.questionId];

  if (question.showIf.equals !== undefined) {
    return target === question.showIf.equals;
  }

  if (question.showIf.includes !== undefined) {
    return Array.isArray(target) && target.includes(question.showIf.includes);
  }

  return true;
}
